import * as React from 'react';
import { observer } from 'mobx-react';
import { observable, action } from 'mobx';

import { ApiStore } from '../../stores/ApiStore';
import { inject, bind } from '../../utils/decorators';

@observer
export default class ProgressBar extends React.Component<{}, {}> {

  @inject(ApiStore) apiStore: ApiStore;
  firstRender: boolean = true;

  render() {
    return <LoadingIndicator show={this.apiStore.isLoading} width={3} background="#008ac1" />;
  }
}

interface ILoadingIndicatorProps {
  show: boolean;
  width: number;
  background?: string;
  zIndex?: number;
}

type LoadingState = 'show' | 'hide' | 'end';

@observer
class LoadingIndicator extends React.Component<ILoadingIndicatorProps, {}> {

  public static defaultProps: ILoadingIndicatorProps = {
    show: false,
    width: 2,
    background: '#77b6ff',
    zIndex: 1200
  };

  @observable loadingState: LoadingState = 'end';

  @action setLoadingState(state: LoadingState) {
    this.loadingState = state;
  }

  componentWillReceiveProps(props: ILoadingIndicatorProps) {
    if (this.props.show === props.show) {
      return;
    }
    const newLoadintState = (props.show) ? 'show' : 'hide';
    this.setLoadingState(newLoadintState);
  }

  @bind handleTransitionEnd() {
    this.setLoadingState('end');
  }

  render() {
    const { show, width, background, zIndex, children, ...props } = this.props;

    let style: React.CSSProperties = {
      position: 'fixed',
      top: '0',
      left: '0',
      right: '0',
      margin: '',
      zIndex: this.props.zIndex,
      height: `${this.props.width}px`,
      background: this.props.background,
      boxShadow: this.props.background + ' 0px 0px 10px'
    };

    switch (this.loadingState) {
      case 'show':
        style.width = '70%';
        style.transition = 'width 10s cubic-bezier(0, 1, 0.3, 1)';
        break;
      case 'hide':
        style.width = '100%';
        style.transition = 'width 400ms ease';
        break;
      case 'end':
        style.width = '0';
        style.transition = 'width 0ms';
        break;
      default:
        break;
    }

    return (
      <div {...props} style={style} onTransitionEnd={this.handleTransitionEnd} />
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/site/ProgressBar.tsx